export const applyWebviewHeight = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => {}
  }

  const setHeight = () => {
    const height = (window.visualViewport && window.visualViewport.height) || window.innerHeight
    document.documentElement.style.setProperty('--app-height', height + 'px')
  }

  setHeight()
  window.addEventListener('resize', setHeight)
  window.addEventListener('orientationchange', setHeight)
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setHeight)
  }

  return () => {
    window.removeEventListener('resize', setHeight)
    window.removeEventListener('orientationchange', setHeight)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', setHeight)
    }
    document.documentElement.style.removeProperty('--app-height')
  }
}

export default applyWebviewHeight
